/**
 * Luật thuần của màn Khoá API (ADR-0068): hạn dùng, kiểm tên, đặt lỗi của
 * server vào đúng ô quyền, lọc danh sách. Không gọi HTTP, không chạm React.
 */
import type { ApiKey } from '../types';

/** Số ngày kể từ hôm nay, hoặc `'khong'` là không hết hạn. */
export type HanDung = number | 'khong';

/** Tên tối đa 100 ký tự sau khi cắt khoảng trắng (schema `ApiKeyCreate`). */
export const TEN_TOI_DA = 100;

export type LoiTen = 'trong' | 'dai';

export function kiemTen(ten: string): LoiTen | null {
  const t = ten.trim();
  if (t === '') return 'trong';
  if (t.length > TEN_TOI_DA) return 'dai';
  return null;
}

/**
 * `expires_at` gửi lên: `null` khi không hết hạn, còn lại là thời điểm sau
 * `bayGio` đúng `han` ngày (ISO 8601, UTC). Backend đòi ít nhất 1 giờ nữa.
 */
export function hanThanhIso(han: HanDung, bayGio: Date): string | null {
  if (han === 'khong') return null;
  return new Date(bayGio.getTime() + han * 24 * 60 * 60 * 1000).toISOString();
}

/** Mã module duy nhất của một tập quyền, theo thứ tự xuất hiện. */
export function moduleCuaKhoa(scopes: readonly string[]): string[] {
  return [...new Set(scopes.map((s) => s.split(':')[0] ?? s).filter(Boolean))];
}

/**
 * Lỗi `422 PERMISSION_NOT_AVAILABLE` trỏ `/scopes/{i}` → lỗi theo mã quyền đã
 * gửi, để lưới chọn quyền hiện đúng dưới ô sai.
 */
export function loiTheoPhamVi(
  loiTruong: Record<string, string>,
  daGui: readonly string[],
): Record<string, string> {
  const ra: Record<string, string> = {};
  for (const [duongDan, thongDiep] of Object.entries(loiTruong)) {
    const m = /^\/scopes\/(\d+)$/.exec(duongDan);
    const ma = m ? daGui[Number(m[1])] : undefined;
    if (ma) ra[ma] = thongDiep;
  }
  return ra;
}

/** Bộ lọc của màn: theo trạng thái (`'tat-ca'` là không lọc) và từ khoá trên tên hoặc tiền tố. */
export function locKhoa(ds: readonly ApiKey[], trangThai: ApiKey['status'] | 'tat-ca', tuKhoa: string): ApiKey[] {
  const q = tuKhoa.trim().toLocaleLowerCase('vi');
  return ds.filter(
    (k) =>
      (trangThai === 'tat-ca' || k.status === trangThai) &&
      (q === '' || k.name.toLocaleLowerCase('vi').includes(q) || k.key_prefix.toLowerCase().includes(q)),
  );
}

/** Thu hồi được khi chưa thu hồi; khoá hết hạn vẫn thu hồi được để đóng hẳn. */
export const thuHoiDuoc = (k: ApiKey): boolean => k.status !== 'REVOKED';
